import { atomFamily } from "recoil";
import { TableId } from "types/models";

import { FilterRule } from "../types/filter";

export const filterAtom = atomFamily<FilterRule[], TableId>({
    key: "filterAtomFamily",
    default: [],
});
